import axios from 'axios'
import { getToken, removeToken } from '@/store/local/auth'
import authService from '@/services/AuthService'
import { Message } from 'element-ui'

// 防重复处理 token 失效的标志位
let isHandlingTokenExpired = false

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // API 基础路径
  withCredentials: true, // 跨域请求时发送 cookie
  timeout: 600000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken()
    }
    // 统一追加终端标识
    if (!config.headers) config.headers = {}
    config.headers['terminal'] = '4'
    return config
  },
  error => {
    console.log(error) // 打印错误信息用于调试
    return Promise.reject('失败'+error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response
    if (res.status != 200) {
      if (res.status == 403 || res.status == 401) {
        // 统一处理登录超时（防重复处理）
        if (!isHandlingTokenExpired) {
          isHandlingTokenExpired = true
          authService.handleLoginExpired('您的登录已过期，请重新登录')
          setTimeout(() => { isHandlingTokenExpired = false }, 2000)
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // 全局处理 token 无效（防重复处理）
      if (res.data && typeof res.data.msg === 'string' && res.data.msg.includes('token参数无效')) {
        if (!isHandlingTokenExpired) {
          isHandlingTokenExpired = true
          try { removeToken() } catch (e) {}
          authService.handleLoginExpired('您的登录已失效，请重新登录')
          setTimeout(() => { isHandlingTokenExpired = false }, 2000)
        }
        return Promise.reject(new Error(res.data.msg))
      }
      // 统一处理业务错误 - 登录相关接口
      if (res.data && res.data.code !== 1) {
        const url = response.config.url || '';
        // 判断是否为登录相关的接口
        if (url.includes('/api/login/') || url.includes('/api/sms/sendCode')) {
          // 登录相关错误，统一在拦截器处理
          const errorMessage = res.data.msg
          
          // 先创建错误对象
          const error = new Error(errorMessage);
          error.code = res.data.code;
          error.response = res.data;
          
          // 显示错误消息
          Message({
            message: errorMessage,
            type: 'error',
            duration: 3000
          });
          // 确保Promise被reject
          return Promise.reject(error);
        }
      }
      return res
    }
  },
  error => {
    console.log('err' + error) // 打印错误信息用于调试
    
    // 处理401/403错误（防重复处理）
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (!isHandlingTokenExpired) {
        isHandlingTokenExpired = true
        authService.handleLoginExpired('您的登录已过期，请重新登录')
        setTimeout(() => { isHandlingTokenExpired = false }, 2000)
      }
    }
    
    return Promise.reject(error)
  }
)

export default service